var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1673 6.37565V27.6257C31.1673 28.565 30.7942 29.4658 30.13 30.13C29.4658 30.7942 28.565 31.1673 27.6257 31.1673H6.37565C5.43634 31.1673 4.53551 30.7942 3.87131 30.13C3.20712 29.4658 2.83398 28.565 2.83398 27.6257V6.37565C2.83398 5.43634 3.20712 4.53551 3.87131 3.87131C4.53551 3.20712 5.43634 2.83398 6.37565 2.83398H27.6257C28.565 2.83398 29.4658 3.20712 30.13 3.87131C30.7942 4.53551 31.1673 5.43634 31.1673 6.37565ZM27.6257 6.37565H6.37565V17.6736L10.2538 13.7954L19.5152 23.0569L21.2861 21.2861C21.8246 20.8553 22.5026 20.6372 23.1913 20.6731C23.8801 20.709 24.5317 20.9964 25.0225 21.4809L27.6257 24.084V6.37565ZM18.7715 12.5736C18.7715 11.8691 19.0513 11.1935 19.5495 10.6953C20.0476 10.1972 20.7233 9.91732 21.4277 9.91732C22.1322 9.91732 22.8078 10.1972 23.306 10.6953C23.8041 11.1935 24.084 11.8691 24.084 12.5736C24.084 13.278 23.8041 13.9537 23.306 14.4518C22.8078 14.95 22.1322 15.2298 21.4277 15.2298C20.7233 15.2298 20.0476 14.95 19.5495 14.4518C19.0513 13.9537 18.7715 13.278 18.7715 12.5736Z",
    fill: "#D1D5DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.191cb946a386ce63d2ee481a2b2e63aa.svg";
export { ForwardRef as ReactComponent };